import React, { Component } from 'react';

import { 
  ThemeProvider, 
  createTheme,
  // styled, 
} from '@mui/material/styles';
import { 
  Grid,
  // Paper,
  // Container,
  Box,
  // FormControl, 
  // InputLabel, 
  MenuItem, 
  Select, 
  SelectChangeEvent 
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

import { withTranslation } from 'react-i18next';
import i18n from '../assets/locales';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import '../assets/css/header.css';

import logo from '../assets/images/logo_white.png';


type Props = {};

type State = {
  lang: string;
}

const theme = createTheme({
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          height: 24,
          color: 'rgba(224, 224, 224, 0.98)' ,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: 24,
          color: 'rgba(224, 224, 224, 0.98)' ,
        },
      },
    },
  },
});

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: (theme.vars ?? theme).palette.text.secondary,
//   ...theme.applyStyles('dark', {
//     backgroundColor: '#1A2027',
//   }),
// }));

class Header extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.handleChangeLanguage = this.handleChangeLanguage.bind(this);

    this.state = {
      lang: localStorage.getItem('lang') ?? 'en'
    };
  }

  componentDidMount() {
  }

  handleChangeLanguage(event: SelectChangeEvent) {
    const lang = event.target.value;

    console.log(`handleChangeLang: ${lang}`);

    localStorage.setItem('lang', lang ?? 'en');

    this.setState({lang: lang});
    i18n.changeLanguage(lang);
  };
  
  render() {
    const { lang } = this.state;

    // const initialValues = {
    //   lang: 'en',
    // };

    return (
      <header>
        <Box sx={{ flexGrow: 1, p: 2 }}>
          <Grid container 
                spacing={2}
                // sx={{
                //   '--Grid-borderWidth': '1px',
                //   borderTop: 'var(--Grid-borderWidth) solid',
                //   borderLeft: 'var(--Grid-borderWidth) solid',
                //   borderColor: 'rgba(255, 255, 255, 1)',
                //   '& > div': {
                //     borderRight: 'var(--Grid-borderWidth) solid',
                //     borderBottom: 'var(--Grid-borderWidth) solid',
                //     borderColor: 'rgba(255, 255, 255, 1)',
                //   },
                //   justifyContent: 'flex-end',
                // }}
                >
            <Grid display='flex' justifyContent='left' size='grow'>
              <img src={logo} alt='SquareGolf' />
            </Grid>
            <Grid display='flex' 
                  justifyContent='right'
                  alignItems='top'
                  size={4}>
              <ThemeProvider theme={theme}>
                <LanguageIcon />
                <Select id='select-language'
                        value={lang}
                        onChange={this.handleChangeLanguage}
                        sx={{'& .MuiSelect-icon': {color: 'rgba(224, 224, 224, 0.98)'}}}>
                  <MenuItem value='en'>English</MenuItem>
                  <MenuItem value='ko'>한국어</MenuItem>
                  <MenuItem value='ja'>日本語</MenuItem>
                </Select>
              </ThemeProvider>
            </Grid>
          </Grid>
        </Box>
      </header>
    );
  }
}

export default withTranslation()(Header);
